export default "__VITE_ASSET__BwV4cgYG__"